angular.module('gym.contacts').factory('LoadInterruptionRequestsService', ["$q", "$http", "$rootScope", function($q, $http, $rootScope) {
  var loadDebounced;
  loadDebounced = _.debounce((function(deferred) {
    return $http.get(`/gyms/${$rootScope.gym.id}/membership_interruption_requests/pending_count`).then(function(response) {
      return deferred.resolve(response.data);
    }, function(response) {
      return deferred.reject(response);
    });
  }), 1000);
  return {
    load: function() {
      var deferred;
      deferred = $q.defer();
      loadDebounced(deferred);
      return deferred.promise;
    }
  };
}]);
